import React, { useEffect, useRef, useState } from 'react'
import App from '../LayoutMobile'
import { Button, Card, Input, message, Spin, Tag, Typography } from 'antd'
import { useNavigate } from "react-router-dom";
import moment from 'moment';
import axios from 'axios';
import { Config } from '../Common/Config';
import { clearAuthAndRedirect } from '../Common/auth';
const { Title } = Typography;

const Home = (props) => {
  const navigate = useNavigate();
  const [selected, setSelected] = useState(null);
  const [allClinicData, setallClinicData] = useState([])
  const [allBucketData, setallBucketData] = useState(null)
  const [allClinicDataByID, setallClinicDataByID] = useState(null)
  const [messageApi, contextHolder] = message.useMessage();
  const [loader, setloader] = useState(false)
  const [durationObjectById, setdurationObjectById] = useState(null);
  const [languageData, setlanguageData] = useState([])//options
  const hasFetched = useRef(false);
  // console.log('props Home:::', Config)
  useEffect(() => {
    if (!hasFetched.current) {
      getAllClinicData()
      getAllBucketsBookingCopyData()
      getAllLanguages()
      getAllBucketsData()
      hasFetched.current = true;
    }
  }, [])
  const getAllBucketsData = async () => {
    try {
      const response = await axios.get(`${Config.url}clinic-bucket-pricing`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response?.data?.data?.data && response?.data?.data?.data.length) {
        // console.log('response?.data?.data :::', response?.data?.data?.data)
        let obj = {}
        response?.data?.data?.data.map(a => {
          obj[a.id] = a
        })
        setallBucketData(obj)
        hasFetched.current = false;
      } else {

      }
    } catch (error) {
      console.log('error in get clinic-bucket-pricing data ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
    }
  }
  const getAllLanguages = async () => {

    try {
      let url = `${Config.url}get-languages`

      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log('response languages ::::', response.data.data.data)
      let languageData = [], objbyid = {}
      if (response && response.data && response.data.data && response.data.data.data) {
        response.data.data.data.map(lan => {
          languageData.push({
            label: lan.language_name,
            value: lan.language_id,
          })
          objbyid[lan.language_id] = lan.language_name
        })
        setlanguageData(languageData)
      }
    } catch (error) {
      console.log('error in getAllLanguages ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
    setloader(false)
  }
  const getAllBucketsBookingCopyData = async () => {
    setloader(true)
    try {
      const response = await axios.get(`${Config.url}duration`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      if (response?.data?.data) {
        // console.log(':::response?.data?.data::::::', response?.data?.data)
        let durationObject = {}
        if (response?.data?.data && response?.data?.data.length) {
          response?.data?.data.map(duration => {
            durationObject[duration.duration_id] = duration
          })
        }
        // console.log(':::durationObject::::::', durationObject)
        setdurationObjectById(durationObject)
        hasFetched.current = false;
      } else {

      }
      setloader(false)
    } catch (error) {
      console.log('error in get clinic-bucket-pricing data ::::', error)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
      setloader(false)
    }
  }
  const getAllClinicData = async () => {
    setloader(true)
    try {
      const response = await axios.get(`${Config.url}clinic?per_page=-1`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });
      // console.log('response?.data?.data :clinic:::', response?.data?.data)
      if (response?.data?.data && response?.data?.data.data && response?.data?.data.data.length > 0) {
        let allClinicDataByID = {}
        response.data.data.data.map((item) => {
          allClinicDataByID[item.id] = item
        })
        // console.log('allClinicDataByID ::::', allClinicDataByID)
        setallClinicDataByID(allClinicDataByID)
      }
      setallClinicData(response?.data?.data)
      hasFetched.current = false;
      setloader(false)
    } catch (error) {
      console.log('error in get clinic data ::::', error)
      setloader(false)
      messageApi.error({
        type: 'error',
        content: error.response?.data?.message || error.message || "Something went wrong",
      });
    }
  }




  let tempUserData = localStorage.getItem('userData'), userData = {}
  if (tempUserData) {
    userData = JSON.parse(tempUserData)
  }

  const openCalenderPage = (clinic) => {
    if (!clinic) {
      return
    }
    // setSelected(clinic.name)
    navigate('/clinic-calendar-page', { state: { clinic: clinic, allClinicData: allClinicData, allClinicDataByID: allClinicDataByID, date: moment().format("YYYY-MM-DD") || '2025-05-15', durationObjectById: durationObjectById, languageData: languageData, allBucketData: allBucketData } })//moment().format("YYYY-MM-DD")}
  }
  return (
    <App >
      {contextHolder}
      <div style={{ height: "100vh", backgroundColor: "#f5fafa", }}>
        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button type="default" className='add-generic-btn' style={{ marginTop: 10, marginInlineEnd: 150, borderColor: '#008385' }} onClick={clearAuthAndRedirect}>Logout</Button>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",

          }}
        >
          <Card
            title={<Title level={4} style={{ color: "white", margin: 0 }}>Last login</Title>}
            headStyle={{ backgroundColor: "#00979D", textAlign: "center", borderStartEndRadius: 20, borderStartStartRadius: 20 }}
            style={{
              width: 460,
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#f5fafa",
            }}
          >
            <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <label style={{ fontWeight: 500 }}>Date:</label>
                <Input placeholder="dd/mm/yyyy" style={{ flex: 1 }} value={moment(userData.last_login_date).format("DD/MM/YYYY")} disabled />
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                <label style={{ fontWeight: 500 }}>Time:</label>
                <Input placeholder="00:00" style={{ flex: 1 }} value={userData.last_login_time} disabled />
              </div>
            </div>
          </Card>
        </div>
        <div style={{ display: 'grid', justifyContent: 'center', marginTop: 30 }}>
          <div style={{ display: 'flex' }}>
            {allClinicData && <div style={{ display: "flex", justifyContent: 'flex-start', alignItems: "center", marginBottom: "10px" }}>
              <Title level={5} style={{ margin: 0, color: "#008385", fontSize: 20 }}>
                All clinic <span style={{ color: "black", fontWeight: '400' }}>({allClinicData?.total ? allClinicData.total : '00'})</span>
              </Title>
            </div>}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: 0

            }}
          >
            <Card style={{ width: 950, textAlign: "center", borderRadius: 12 }}>
              <Title level={4} style={{ background: "#008385", color: "#fff", padding: "10px", borderRadius: "10px 10px 0 0", margin: 0 }}>
                Clinic calendars
              </Title>
              <div style={{ padding: "20px", display: "flex", flexWrap: "wrap", gap: "10px", justifyContent: "left" }}>
                {loader == false && allClinicData && allClinicData.data && allClinicData.data.length ? allClinicData.data.map((clinic) => {
                  // console.log(clinic.name,'clinic.status ::',clinic.status)
                  return clinic.status != 0 ? <Tag
                    key={clinic.id}
                    onClick={() => setSelected(clinic)}
                    style={{
                      padding: "8px 15px",
                      fontSize: "16px",
                      fontWeight: 400,
                      borderRadius: "15px",
                      cursor: "pointer",
                      lineHeight: 1,
                      transition: 'all 0.2s',
                      backgroundColor: selected?.id === clinic.id ? '#008385' : '#F0FAFA',
                      color: selected?.id === clinic.id ? '#ffffff' : '#4A4A4A',
                      border: selected?.id === clinic.id ? '1px solid #008385' : '1px solid transparent',
                    }}
                  >
                    {clinic.name}
                  </Tag> : ''
                }
                  
                ) : <Spin className="custom-spinner" />}
              </div>
              {loader == false && allClinicData && allClinicData.data && allClinicData.data.length && <Button
                type="primary"
                size="large"
                disabled={!selected}
                style={{
                  width: 215,
                  backgroundColor: selected ? '#008385' : undefined,
                  height: 40,
                  opacity: selected ? 1 : 0.5,
                  cursor: selected ? 'pointer' : 'not-allowed',
                }}
                onClick={() => openCalenderPage(selected)}
              >View</Button>}
            </Card>
          </div>
        </div>
      </div>
    </App>
  )
}


export default Home
